/* src/app/components/ai-library/ai-library/new-ai-library/new-ai-library.component.scss */
.notification-content-wrapper {
  height: calc(100vh - 200px);
  overflow-y: auto;
}
.modal-dialog .modal-content {
  max-width: calc(100vw - 50px);
}
.modal-dialog .modal-header {
  justify-content: space-between;
}
.modal-dialog .modal-body {
  height: calc(100vh - 150px);
  overflow-y: auto;
  scrollbar-width: none;
}
.modal-dialog .fa-solid {
  font-size: 1.5rem !important;
  color: #fff !important;
}
.modal.fade {
  background: rgba(0, 0, 0, 0.2);
}
.modal.show {
  display: block;
}
.modal-header {
  background: var(--primaryColor);
  color: #fff;
}
.btn-close {
  color: #fff;
}
.userlist {
  height: calc(100vh - 500px);
  overflow-y: auto;
}
.btn-primary {
  background: var(--primaryColor) !important;
  color: #fff !important;
}
.btn-cancel {
  background-color: #eee;
  color: #111;
}
.btn {
  padding: 0.3rem 0.8rem !important;
}
/*# sourceMappingURL=new-ai-library.component.css.map */
